// extracted by mini-css-extract-plugin
export var form = "Form-module--form--5307f";
export var inputsContainer = "Form-module--inputsContainer--e7f72";